import { Component } from '@angular/core';
import { TitleService } from '../../../services/title.service';

@Component({
  selector: 'app-contact-us-page',
  imports: [],
  templateUrl: './contact-us-page.html',
  styleUrl: './contact-us-page.scss',
})
export class ContactUsPage {
  constructor(private titleService: TitleService) {
    this.titleService.setTitle('Contact Us');
  }
}
